/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const StarHalf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Star half"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#DADADA"
        d="M10.928 2.835a1.177 1.177 0 0 1 2.144 0l2.164 4.549c.174.366.511.62.9.678l4.839.73c.98.148 1.372 1.398.663 2.116l-3.501 3.54a1.27 1.27 0 0 0-.344 1.099l.826 5c.168 1.013-.858 1.786-1.735 1.308l-4.328-2.36a1.16 1.16 0 0 0-1.112 0l-4.328 2.36c-.877.478-1.903-.295-1.735-1.308l.826-5a1.27 1.27 0 0 0-.343-1.098l-3.502-3.541c-.71-.718-.318-1.968.663-2.116l4.839-.73a1.2 1.2 0 0 0 .9-.678z"
      />
      <path
        fill="#FFC220"
        d="M10.928 2.832a1.177 1.177 0 0 1 2.144 0l2.164 4.549c.174.366.511.62.9.678l4.839.73c.98.148 1.372 1.398.663 2.116l-3.501 3.54a1.27 1.27 0 0 0-.344 1.099l.826 5c.168 1.013-.858 1.786-1.735 1.308l-4.328-2.36a1.16 1.16 0 0 0-1.112 0l-4.328 2.36c-.877.478-1.903-.295-1.735-1.308l.826-5a1.27 1.27 0 0 0-.343-1.098l-3.502-3.541c-.71-.718-.318-1.968.663-2.116l4.839-.73a1.2 1.2 0 0 0 .9-.678z"
      />
      <path
        fill="#DADADA"
        d="m15.236 7.38-2.164-4.548A1.18 1.18 0 0 0 12 2.14v17.375s.208-.214.556-.024l4.328 2.36c.877.48 1.903-.294 1.735-1.307l-.826-5a1.27 1.27 0 0 1 .344-1.098l3.5-3.541c.71-.718.319-1.968-.662-2.116l-4.838-.73a1.2 1.2 0 0 1-.9-.678"
      />
    </g>
  </svg>
);

export const StarHalfIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-half-icon'}
      icon={StarHalf}
      {...props}
      size={size}
    />
  );
};
